import React, { useState } from 'react';
import _ from 'lodash';

import { MetadataContent } from '@jutro/legacy/uiconfig';

import { FormattedMessage } from '@jutro/locale';
import metadata from './SelectVehiclePopupComponent.metadata.json5';
import bodyStyle from './SelectVehiclePopupComponent.module.scss';
import messages from './SelectVehiclePopupComponent.messages';

function SelectVehiclePopupComponent(props) {
    const {
        viewModel: vehiclesInfo
    } = props;

    const [selectedVinPrefix, setSelectedVinPrefix] = 
        useState(() => {
            if (!_.isEmpty(vehiclesInfo)) {
                // select the first vehicle
                vehiclesInfo[0].checked = true;
                return vehiclesInfo[0].vinPrefix;
            }
            return null;
        });

    const generateVehicleListOverrides = () => {
        const overrides = vehiclesInfo.map((currentVehicle, index) => {
            return {
                [`selectRadio${index}`]: {
                    availableValues: [{
                        code: currentVehicle.vinPrefix,
                        name: ''
                    }],
                    value: selectedVinPrefix,
                    onValueChange: (value) => {
                        setSelectedVinPrefix(value);
                        // pass indicator back to caller
                        vehiclesInfo.find((v) => v.checked).checked = false;
                        vehiclesInfo.find((v) => v.vinPrefix === value).checked = true;
                    }
                },
                [`symbolsContent${index}`]: {
                    content: (
                        <FormattedMessage
                            {...messages.symbolsPopupMsg}
                            values={{
                                compSymbol: currentVehicle.compSymbol,
                                collSymbol: currentVehicle.collSymbol,
                                br: (<br />)
                            }}
                        />
                    )
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrides = {
        tableRowIterable: {
            data: vehiclesInfo
        },
        ...generateVehicleListOverrides()
    };

    const resolvers = {
        resolveClassNameMap: bodyStyle,
        resolveCallbackMap: {
            setSelectedVinPrefix
        }
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}

export default SelectVehiclePopupComponent;